import type { MarketplaceProperty } from '../types';
import { listingReelTransformUrl } from './listingReelTransform';

const PUBLIC_LISTING_REEL =
  /^https:\/\/images\.opendoor\.com\/source\/s3\/cabinet-assets\/(?:production|staging)\/storage\/video\/listing-reel\/[\da-f]{8}-(?:[\da-f]{4}-){3}[\da-f]{12}\.mp4$/u;

export const listingReelPreviewUrl = (
  property: Pick<MarketplaceProperty, 'walkthroughVideos'>,
): string | null => {
  // Messages downloads the asset directly, so use a public MP4 and the same
  // compact rendition as the mobile PDP instead of an HTML player or full-size reel.
  const reel = property.walkthroughVideos.find((video) => PUBLIC_LISTING_REEL.test(video.url));
  return reel ? listingReelTransformUrl(reel.url, 480) : null;
};
